"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyScrolling = void 0;
exports.getBackground = getBackground;
exports.getBorderRadius = getBorderRadius;
exports.getPlaceholderComputedStyle = getPlaceholderComputedStyle;
let bodyNode;
function getBodyNode() {
  if (!bodyNode) {
    bodyNode = document.querySelector('body');
  }
  return bodyNode;
}
function computeCoordinateScaleValue(initialCoordinate, nodeSize, windowCoordinate) {
  const intermediateCoordinate = windowCoordinate - initialCoordinate - nodeSize;
  const maxCoordinate = Math.max(initialCoordinate, intermediateCoordinate);
  const scaleValue = (maxCoordinate * 2 + nodeSize) / nodeSize;
  return Math.ceil(scaleValue * 10) / 10;
}
function getScaleValues(node, top, left) {
  return {
    scaleX: computeCoordinateScaleValue(left, node.offsetWidth, window.innerWidth),
    scaleY: computeCoordinateScaleValue(top, node.offsetHeight, window.innerHeight)
  };
}
const bodyScrolling = exports.bodyScrolling = {
  lock() {
    getBodyNode().style.overflow = 'hidden';
  },
  unlock() {
    getBodyNode().style.removeProperty('overflow');
  }
};
function getPlaceholderComputedStyle(trigger, placeholder) {
  const top = trigger.offsetTop - window.scrollY;
  const left = trigger.offsetLeft - window.scrollX;
  const placeholderScale = getScaleValues(placeholder, top, left);
  return "\n  top: ".concat(top, "px;\n  left: ").concat(left, "px;\n  transform: scale(").concat(placeholderScale.scaleX * 1.5, ",").concat(placeholderScale.scaleY * 1.5, ");\n");
}
function getBorderRadius(styles) {
  const {
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomLeftRadius,
    borderBottomRightRadius
  } = styles;
  return "\n    border-top-left-radius: ".concat(borderTopLeftRadius, ";\n    border-top-right-radius: ").concat(borderTopRightRadius, ";\n    border-bottom-left-radius: ").concat(borderBottomLeftRadius, ";\n    border-bottom-right-radius: ").concat(borderBottomRightRadius, ";\n  ");
}
function getBackground(styles) {
  if (styles.background && styles.background.length > 0) {
    return styles.background;
  }
  if (styles.backgroundImage && styles.backgroundImage.length > 0 && styles.backgroundImage !== 'none') {
    return styles.backgroundImage;
  }
  if (styles.backgroundColor && styles.backgroundColor.length > 0) {
    return styles.backgroundColor;
  }
  return '';
}